import React, { Component } from 'react';
import { Route } from 'react-router';
import { appService } from '../../_services';
//import fs from 'react-fs';
var parameters

export class sitemap extends Component {

    constructor(props) {
        super(props);
       
    }

    componentDidMount() {
       
        parameters = {
            file: window.location.origin,
            filename: "sitemap.xml"
        }
        // console.log(parameters);
        appService.getByArticleId('Product/RenderSitemapXML', parameters)
            .then(function (data) {

            })
    }

    render() {
        
        return (
            <div></div>
        )
    }
}
export default sitemap;


// WEBPACK FOOTER //
// ./src/components/Google_Scholar/sitemap.js